import axios from 'axios';
import { authFetch } from './authFetch';

const API_URL = '/api';

export async function login(username: string, password: string) {
  const response = await axios.post(`${API_URL}/token/`, { username, password });
  return response.data; // { access, refresh }
}

export async function getUserInfo(accessToken: string) {
  const res = await authFetch(`${API_URL}/user/`, {}, accessToken);
  if (!res.ok) throw new Error('Failed to fetch user info');
  return res.json();
}